export const BULK_SEGMENT_UPDATE_SAMPLE_CSV_URL: string =
	'https://zupee-common-test-bucket.s3.ap-south-1.amazonaws.com/prod/bulkSegmentUpdateSampleProd.csv';
